import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=256ee5a4&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=256ee5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ee5a4",
  null
  
)

export default component.exports